module.exports = __webpack_public_path__ + "img/hero4.d1ccfe4b.jpg";